import { render, staticRenderFns } from "./LanguagesComponents.vue?vue&type=template&id=3ca7fde7&scoped=true"
import script from "./LanguagesComponents.vue?vue&type=script&lang=js"
export * from "./LanguagesComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7fde7",
  null
  
)

export default component.exports